export default __webpack_public_path__ + "static/media/teacup-dark.a8ec136d.svg";